import { render, staticRenderFns } from "./GenericServiceConfig.vue?vue&type=template&id=390fe46f"
import script from "./GenericServiceConfig.vue?vue&type=script&lang=js"
export * from "./GenericServiceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports